module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"_title":"Blank","subtitle":"This is a blank page for demo use"},"zh":{"_title":"空白","subtitle":"本页面仅作测试之用"}}')
  delete Component.options._Ctor
}
